/**
 * Read-only value display
 */

import { formatValue } from '../utils';

interface ValueDisplayProps {
  value: any;
}

export function ValueDisplay({ value }: ValueDisplayProps) {
  return (
    <span style={{
      color: '#9ca3af',
      fontFamily: 'monospace',
      fontSize: 11,
      marginLeft: 'auto',
      maxWidth: 120,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }}>
      {value !== undefined ? formatValue(value) : ''}
    </span>
  );
}
